export enum FormEventsEnum {
  FORM_SUBMITTED = "form:submitted"
}
